/* @flow weak */
import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate([
  'DELETE',
  'LOAD_RELATIONSHIP',
  'UPDATE_RELATIONSHIP',
]);



// WEBPACK FOOTER //
// ./src/constants/RelationshipConstants.js